import { useMutation } from '@tanstack/react-query';

import type { Vacancy } from 'clients/AutoCompleteClient/types';

import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { queryClient } from 'config/queryClient';
import { useGTM } from 'hooks/gtm';
import { QueryKey } from 'types/query';

export const useDeleteJobImprovedMutation = () => {
  const gtm = useGTM();

  return useMutation(
    async (vacancy: Vacancy) => {
      if (!vacancy.db_id) throw Error('Vacancy ID is required');
      const dbId = Number(vacancy.db_id);

      return reachoutClient.deleteJobImproved(dbId);
    },
    {
      onSuccess: () => {
        gtm.removedEnrichedJob();
        queryClient.invalidateQueries([QueryKey.useEnrichedVacanciesQuery], { exact: false });
      },
    },
  );
};
